export default __webpack_public_path__ + "static/media/plant-flag.22052eeb.svg";